module.exports = __webpack_public_path__ + "static/img/background.25ba0f19.svg";